import { FC } from 'react'
import { Settings } from './settings.tsx'
import { MainContent } from '../../components/main-content.tsx'
import { MainContentHeader } from '../../components/main-content-header.tsx'
import { MainContentBody } from '../../components/main-content-body.tsx'
import { Layout } from '../../components/layout.tsx'

export const SettingsPage: FC = () => {
  return (
    <Layout>
      <MainContent>
        <MainContentHeader breadcrumbs={[{ label: 'Settings', href: '/settings' }]} />
        <MainContentBody>
          <Settings />
        </MainContentBody>
      </MainContent>
    </Layout>
  )
}
